<template>
  <div id="settings" class="wrrapper mb-1">
    <page-heading title="Error Logs" border>
      <template #content>
        <div class="flex align-center">
          <Button
            :onClick="handleClearAllLogs"
            className="button--primary add-user mr-2"
            title="Clear All Logs"
          ></Button>
        </div>
      </template>
    </page-heading>
    <div class="settings-template">
      <data-table
        :cols="columns"
        :rows="logs"
        height="calc(100vh - 15rem)"
        :loading="loading"
      >
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu :rowData="actions" :handleItemClick="handleItems" />
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
// import FileUplaod from "./../../../components/FileUpload.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Button,
    DataTable,
    DropdownMenu
    // FileUplaod,
  },
  data() {
    return {
      id: "",
      columns: [
        { column: "serial", label: "#", width: "60", sortable: true },
        {
          column: "endpoint_name",
          label: "End point"
        },
        {
          column: "request_method",
          label: "Request Method"
        },
        {
          column: "request_method",
          label: "requested_by"
        },
        {
          column: "error_message",
          label: "Error message"
        },
        {
          column: "time",
          label: "Error log time",
          sortable: true
        }
        // { column: "createdBy", label: "Created By", sortable: true },
        // { column: "action", label: "Actions" },
      ],
      brachData: [],
      registrationData: {
        // branchName: null,
        // branchAddress: null,
        // phoneNumber: null,
        // email: null,
        // logoUrl: null,
        // attachmentId: null,
      },
      logs: []
    };
  },
  methods: {
    ...mapActions("bussiness", [
      "addBussinessSettings",
      "updateSettings",
      "settingsList",
      "createBranch",
      "clearAllLogs",
      "getErrorLogs"
    ]),
    ...mapActions("expenses", ["fetchBranch"]),
    ...mapActions("auth", ["uploadAttachment"]),
    async handleClearAllLogs() {
      await this.clearAllLogs({ id: this.user.userBranchId });
      await this.getlogs();
    },
    async getlogs() {
      await this.getErrorLogs();
      let flattenedLogsArray = [];
      for (const item of this.errorLogs) {
        let lo = item.logs.logs;
        for (const items in lo) {
          flattenedLogsArray.push(lo[items]);
        }
      }
      this.logs = flattenedLogsArray;
    }
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings",
      errorLogs: "bussiness/errorLogs",
      loading: "loading",
      fetchUserBranch: "expenses/fetchUserBranch",
      attachmentId: "auth/attachmentId",
      attachmentUrl: "auth/attachmentUrl",
      user: "auth/userInfo"
    })
  },
  watch: {
    settings(val) {
      const ref = this.$refs || {};
      const item = val.find(item => item);
      if (item) {
        ref.header.editor.setContents(item.header, "api");
        ref.footer.editor.setContents(item.footer, "api");
        ref.note.editor.setContents(item.note, "api");
        this.id = item.id ? item.id : "";
      }
    }
  },
  async mounted() {
    await this.getlogs();
  }
};
</script>

<style>
#settings .settings-template {
  padding: 22px 65px 22px 65px;
}

#settings .save-template {
  padding: 13px 50px;
  margin-top: 65px;
}

.bussiness-header {
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 25px;
  color: var(--ink-900);
}
</style>
